<template>
  <div class="order-status-step">
    <el-steps :active="activeIndex" finish-status="success" align-center="">
      <el-step v-for="status in showOrderStatusList" :key="status.key" :title="status.value" />
    </el-steps>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'order-status-step',
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    orderType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      orderStatusList: state => state.base.purchaseOrderStatusMap,
      orderPrintStatusList: state => state.base.purchaseOrderStatusMap,
      freezerOrderStatusList: state => state.base.quotaOrderStatusMap
    }),
    showOrderStatusList () {
      if (!this.orderStatusList || !this.orderPrintStatusList || !this.freezerOrderStatusList) return
      switch (this.orderType) {
        case 'menu':
          return this.handleStatusData(this.orderStatusList)
        case 'nonMenu':
          return this.handleStatusData(this.orderStatusList)
        case 'printing':
          return this.handleStatusData(this.orderPrintStatusList)
        case 'freezer':
          return this.handleStatusData(this.freezerOrderStatusList)
        default:
          return []
      }
    },
    activeIndex () {
      if (!this.orderInfo) {
        return -1
      }
      if (!this.showOrderStatusList) {
        return
      }
      for (let i = 0; i < this.showOrderStatusList.length; i++) {
        if (this.showOrderStatusList[i].key === String(this.orderInfo.orderStatus)) {
          return i
        }
      }
      return -1
    }
  },
  created () {
    this.$store.dispatch('getDictByName', 'purchaseOrderStatusMap')
    this.$store.dispatch('getDictByName', 'purchaseOrderStatusMap')
    this.$store.dispatch('getDictByName', 'quotaOrderStatusMap')
  },
  methods: {
    handleStatusData (statusList) {
      const filterData = statusList.filter((item) => {
        return item.key !== '900'
      })
      return filterData
    }
  }
}
</script>

<style lang="scss" scoped>
.order-status-step {
  border-top: solid 1px $base-grey3;
  border-bottom: solid 1px $base-grey3;
  padding: 30px;

  ::v-deep .el-step__head.is-process {
    color: $base-red;
    border-color: $base-red;
  }
  ::v-deep .el-step__title.is-process {
    color: $base-red;
  }
}
</style>
